<form
  class="form w-100"
  novalidate="novalidate"
  [formGroup]="forgotPasswordForm"
  (ngSubmit)="submit()"
>
  <!--begin::Heading-->
  <div class="text-center mb-10">
    <!--begin::Title-->
    <h4 class="text-black font-bold mb-4">Forgot Password ?</h4>
    <!--end::Title-->

    <!--begin::Link-->
    <div class="text-muted font-semibold">
      Enter your email to reset your password.
    </div>
    <!--end::Link-->
  </div>
  <!--begin::Heading-->

  <!-- begin::Alert error-->
  @if (errorState === errorStates.HasError) {
  <div class="lg:mb-15 alert text-danger">
    <div class="alert-text font-weight-bold">
      Sorry, looks like there are some errors detected, please try again.
    </div>
  </div>
  }
  <!-- end::Alert error-->

  @if (errorState === errorStates.NoError) {
  <div class="mb-10 bg-light-info p-20 rounded">
    <!--begin::Body-->
    <div class="text-info">Sent password reset. Please check your email</div>
    <!--end::Body-->
  </div>
  }

  <!--begin::Form group-->
  <div class="flex flex-col mb-20">
    <label class="form-label font-bold text-gray-900 fs-6">Email</label>
    <input
      pInputText
      class="form-control !bg-transparent"
      type="email"
      formControlName="email"
      placeholder="Email"
      name="email"
      autocomplete="off"
      [ngClass]="{
        'is-invalid': forgotPasswordForm.controls['email'].invalid,
        'is-valid': forgotPasswordForm.controls['email'].valid
      }"
    />

    <ng-container
      [ngTemplateOutlet]="formError"
      [ngTemplateOutletContext]="{
        validation: 'required',
        message: 'Email is required',
        control: forgotPasswordForm.controls['email']
      }"
    ></ng-container>
    <ng-container
      [ngTemplateOutlet]="formError"
      [ngTemplateOutletContext]="{
        validation: 'email',
        message: 'Email is invalid',
        control: forgotPasswordForm.controls['email']
      }"
    ></ng-container>
    <ng-container
      [ngTemplateOutlet]="formError"
      [ngTemplateOutletContext]="{
        validation: 'minLength',
        message: 'Email should have at least 3 symbols',
        control: forgotPasswordForm.controls['email']
      }"
    ></ng-container>
    <ng-container
      [ngTemplateOutlet]="formError"
      [ngTemplateOutletContext]="{
        validation: 'maxLength',
        message: 'Email should have maximum 360 symbols',
        control: forgotPasswordForm.controls['email']
      }"
    ></ng-container>
  </div>
  <!--end::Form group-->
  <!--begin::Form group-->
  <div class="flex flex-wrap justify-center">
    <button pButton class="mr-4" [disabled]="!f['email'].valid">
      <span class="indicator-label">Submit</span>
      @if (isLoading$ | async) {
      <span class="indicator-progress">
        Please wait...
        <span class="spinner-border spinner-border-sm align-middle ml-2"></span>
      </span>
      }
    </button>
    <button pButton severity="secondary" routerLink="/auth/login">
      Cancel
    </button>
  </div>
  <!--end::Form group-->
</form>
<!--end::Form-->

<ng-template
  #formError
  let-control="control"
  let-message="message"
  let-validation="validation"
>
  @if (control.hasError(validation) && (control.dirty || control.touched)) {
  <div class="mt-2">
    <span class="text-danger text-sm">{{ message }}</span>
  </div>
  }
</ng-template>
